import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Injector,
  Input,
  Output,
} from '@angular/core';

import { KeypadAction } from '../classes/KeyPad.enums';
import { KeypadConfigType, KeyPadConfig } from '../../../interfaces';

import { E2E_ATTRIBUTES } from '@shared/types/enums/e2e-attributes.enum';

import { BaseComponent } from '@components/base-component';

import type { KeypadEvent } from '../classes/KeyPad.type';

@Component({
  selector: 'keypad-display',
  styleUrls: ['./keypad-display.component.scss'],
  templateUrl: './keypad-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KeypadDisplayComponent extends BaseComponent {
  public placeholder = '';
  public prefix = '';
  public kpType = '';
  public currentValue = '';

  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;
  @HostBinding('attr.e2e-attr')
  public e2eAttr: E2E_ATTRIBUTES = E2E_ATTRIBUTES.KEY_PAD_DISPLAY;

  @Input() public hasInitial = false;
  @Input() public errorMessage = '';
  @Input() public displayedValue = '';
  @Input() public isActive = true;
  @Input() public isInvalid = false;
  @Input() public measure = '';
  @Input() public isDefaultMinValue = false;
  @Input() public className: string | string[];

  /**
   * On input of changed config this function
   * sets the configuration variables to properly
   * manage the specific configuration type.
   * @param keyPadConfig { KeyPadConfig } current keypad configuration data
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  @Input() set config(keyPadConfig: KeyPadConfig) {
    this.prefix = keyPadConfig.prefix;
    this.kpType = keyPadConfig.kpType;
    this.placeholder = keyPadConfig.placeholder;
  }

  @Output() public pop: EventEmitter<KeypadEvent> = new EventEmitter();

  public dotSign = '\u2022';
  public get mask(): string {
    return this.isSecureField() ? this.dotSign : '';
  }

  public constructor(injector: Injector) {
    super(injector);
    this.forceLocalUpdate = true;
  }

  /**
   * onClick emits up one level the request to backspace by 1 character
   */
  public onPop() {
    this.pop.emit({
      action: KeypadAction.POP,
    });
  }

  private isSecureField(): boolean {
    const secureKeypadTypes: string[] = [KeypadConfigType.PIN];
    return secureKeypadTypes.includes(this.kpType);
  }
}
